import React, { PropTypes } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Header from './Header/Header';
import LoginForm from './Session/LoginForm';
import LeftSideMenu from './LeftSideMenu/LeftSideMenu';
import { removeTokenFromSessionStorage, removeUser } from './../actions/sessionActions';
import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-widgets/lib/less/react-widgets.less';

let Moment = require('moment');
let momentLocalizer = require('react-widgets/lib/localizers/moment');
momentLocalizer(Moment);


class App extends React.Component {
   logout = () => {
      this.props.dispatch(removeUser());
      removeTokenFromSessionStorage();
      this.context.router.push('/');
   };

   render() {
      const { user } = this.props;
      const userEmpty = Object.keys(user).length === 0 && user.constructor === Object;
      // const userEmpty = false;
      return (
         <div >
            {userEmpty ? <LoginForm />
               :
               <div >
                  <Header user={user} logout={this.logout} />
                  <Grid fluid >
                     <Row >
                        <Col md={2} >
                           <LeftSideMenu menuLinks={menuLinks} />
                        </Col >
                        <Col md={10} >
                           {this.props.children}
                        </Col >
                     </Row >
                  </Grid >
               </div >
            }
         </div >
      );
   }
}

App.propTypes = {
   children: PropTypes.element,
   dispatch: PropTypes.func,
   user: PropTypes.object
};

App.contextTypes = {
   router: PropTypes.object
};

function mapStateToProps(state) {
   return {
      user: state.sessions
   };
}

export default connect(mapStateToProps)(App);

const menuLinks = [
   {
      // section dashboard
      name: 'Dashboard Zone',
      links: [
         {
            name: 'Dashboard',
            to: ''
         }
      ]
   },
   {
      // section dashboard
      name: 'Contacts Management',
      links: [
         {
            name: 'Contacts',
            to: 'contact'
         },
      ]
   },
   {
      // section
      name: 'Shop Management',
      links: [
         {
            name: 'Shops',
            to: 'shop'
         }
      ]
   },
   {
      // section
      name: 'Item Management',
      links: [
         {
            name: 'Product',
            to: 'product'
         },
         {
            name: 'Services',
            to: 'service'
         },
         {
            name: 'Feature Classes',
            to: 'featureClass'
         },
         {
            name: 'Brand',
            to: 'brand'
         },
         {
            name: 'Manufacturer',
            to: 'manufacturer'
         }
      ]
   },
   {
      name: "Stock Management",
      links: [
         {
            name: 'Present Stock',
            to: 'presentStock'
         },
         {
            name: 'Transfer Stock',
            to: 'transferStock'
         },
         {
            name: 'Lost Adjustment',
            to: 'lostAdjustment'
         },
         {
            name: 'Gain Adjustment',
            to: 'gainAdjustment'
         }
      ]
   },
   {
      // section
      name: 'Invoice Management',
      links: [
         {
            name: 'Purchase',
            to: 'purchase'
         },
         {
            name: 'Purchase Return',
            to: 'purchaseReturn'
         },
         {
            name: 'Sales',
            to: 'sale'
         },
         {
            name: 'Sale Return',
            to: 'saleReturn'
         },
         {
            name: 'Expense',
            to: 'expense'
         },
         {
            name: 'Fixed Asset',
            to: 'fixedAsset'
         },
         {
            name: 'Convert Inventory',
            to: 'convertInventory'
         },
         {
            name: 'Find Invoice By Item',
            to: 'findInvoice'
         }
      ]
   },

   {
      // section
      name: 'Order Management',
      links: [
         {
            name: 'Order',
            to: 'order'
         },
      ]
   },
   {
      // section
      name: 'Accounting',
      links: [
         {
            name: 'Journal Entries',
            to: 'journalEntry'
         },
         {
            name: 'Chart Of Account',
            to: 'chartOfAccount'
         },
         {
            name: 'Trial Balance',
            to: 'trialBalance'
         }
      ]
   },
   {
      name: 'Reports',
      links: [
         {
            name: 'Sales',
            to: 'saleReports'
         },
      ]
   },
];



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/